import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { GoogleBigQueryObjectV2Dataset } from 'app/model/dataset/google-bigquery-v2.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.googleBigQuery.copySourceType : adfModelTypeMap.googleBigQueryV2.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(GoogleBigQueryObjectV2Dataset) }
})
export class GoogleBigQueryV2CopySource extends TabularCopySource {
    public static readonly PARTITION_OPTION: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_OPTION',
        display: stringResources.ModelName_Partition_Option
    })
    public partitionOption?: string = partitionOptionConst.none;
}
